import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "choose-send-type" }
const _hoisted_2 = { class: "el-dialog__body-title" }
const _hoisted_3 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_4 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, watch, nextTick } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'refresh', 'chooseCall'],
  setup(__props, { emit }) {

const props = __props


const sendType = ref(2)



const close = () => {
  emit('update:visible', false)
}

const submit = () => {
  emit('update:visible', false)
  emit('chooseCall', sendType)
}


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('创建国际发货')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_radio_group, {
            modelValue: sendType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sendType).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { label: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('乐天')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('SHOPLIST')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 4 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('ZOZOTOWN')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('其他')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: close }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})